import React from 'react';
import { Router, Route } from 'react-router';
import { createBrowserHistory } from 'history';
const history = createBrowserHistory();

import {
  App,
  // SignIn,
  // SignUp,
  // ResetPwd,
  // ForgotPwd,
  Visitor,
  Widget,
  Profile,
  Payment,
  SignIn,
  // Plan
  //Dashboard,
  //Integration,
  //Review,
  // Post,
  //Pixel,
} from './containers';

let params = new URLSearchParams(window.location.search);
let jwt = params.get('q');
let wdgtp = params.get('wdgtp');
let wdgid = params.get('wdgid');
let wdgshp = params.get('wdgshp');
// let authwn = params.get('authwn');

// setTimeout(() => {
//   console.log('log===from===authwn====>', authwn);
//   if (authwn) {
//     window.location.href = window.location.origin + '/login?wnauth=' + authwn;
//   }
//   else {
//     console.log('log===from===else====>');
//     setTimeout(() => {
//       if (window.localStorage.getItem('authToken') == '' || window.localStorage.getItem('authToken') == undefined)
//         window.location.href = process.env.REACT_APP_WISERNOTIFY_DOMAIN;
//     }, 5000);
//   }
// }, 2000);

//store URL in localstorage
localStorage.setItem('rdt_url', window.location.href);

if (wdgshp !== null && wdgid !== null && wdgtp !== null && jwt !== null) {
  localStorage.setItem('authToken', jwt);
  localStorage.setItem('WIDNM', wdgtp);
  localStorage.setItem('WIDTP', wdgid);
  localStorage.setItem('WIDSHP', wdgshp);
  localStorage.setItem('pvd', 'shopify');
  history.push(process.env.REACT_APP_ROUTE_PREFIX + 'wdlist', { some: 'state' });
}

let cookie = ''; try { cookie = localStorage.getItem('authToken'); } catch (e) {/** error */ }
const MyRoutes = ({ routerHistory }) => (
  <Router history={routerHistory}>
    <Route component={App}>
      {
        cookie ?
          <Route>
            {/* <Route path={`${process.env.REACT_APP_ROUTE_PREFIX}dashboard`} component={Dashboard} />
            <Route path={`${process.env.REACT_APP_ROUTE_PREFIX}integration`} component={Integration} />
            <Route path={`${process.env.REACT_APP_ROUTE_PREFIX}review`} component={Review} />
            <Route path={`${process.env.REACT_APP_ROUTE_PREFIX}post`} component={Post} /> */}
            <Route path={`${process.env.REACT_APP_ROUTE_PREFIX}wdlist`} component={Widget} />
            <Route path={`${process.env.REACT_APP_ROUTE_PREFIX}visitor`} component={Visitor} />
            <Route path={`${process.env.REACT_APP_ROUTE_PREFIX}profile`} component={Profile} />
            {/* <Route path={`${process.env.REACT_APP_ROUTE_PREFIX}plan`} component={Plan} /> */}
            <Route path={`${process.env.REACT_APP_ROUTE_PREFIX}payment`} component={Payment} />
            {/* <Route path={`${process.env.REACT_APP_ROUTE_PREFIX}pixel`} component={Pixel} /> */}
            <Route path={`${process.env.REACT_APP_ROUTE_PREFIX}*`} component={Widget} />
            {/* <Route path={`${process.env.REACT_APP_ROUTE_PREFIX}widget`} component={Widget} /> */}


          </Route>
          :
          <Route>
            {/* <Route path={`${process.env.REACT_APP_ROUTE_PREFIX}`} component={SignIn} /> */}
            {/* <Route path={`${process.env.REACT_APP_ROUTE_PREFIX}login`} component={SignIn} /> */}
            {/* <Route path={`${process.env.REACT_APP_ROUTE_PREFIX}signup`} component={SignUp} /> */}
            {/* <Route path={`${process.env.REACT_APP_ROUTE_PREFIX}reset`} component={ResetPwd} /> */}
            {/* <Route path={`${process.env.REACT_APP_ROUTE_PREFIX}ForgotPwd`} component={ForgotPwd} /> */}
            {/* <Redirect from="*" to="/login" /> */}
            <Route path='*' component={SignIn} />
          </Route>
      }
    </Route>
  </Router>
);

export default MyRoutes;



// WEBPACK FOOTER //
// ./src/Routes.js